// removed by extract-text-webpack-plugin
module.exports = {"pageBody":"_2ugu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/body/style.css
// module id = 181
// module chunks = 9